import Reveal from "./Reveal";
import { Globe2, Target, Compass } from "lucide-react";

const POINTS = [
  {
    icon: Globe2,
    title: "Understand markets",
    text: "A structured perspective on how markets, industries and trade flows connect.",
  },
  {
    icon: Target,
    title: "Identify opportunities",
    text: "Evidence-led identification of openings across products, partners and regions.",
  },
  {
    icon: Compass,
    title: "Decide with confidence",
    text: "Insight organised for decision-makers and ready to be acted upon.",
  },
];

export default function About() {
  return (
    <section id="about" className="relative bg-white py-24 md:py-32">
      <div className="mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:gap-20">
        <div>
          <Reveal>
            <p className="eyebrow">About Us</p>
            <h2 className="font-display text-3xl font-light leading-tight text-navy-900 sm:text-4xl lg:text-[2.75rem]">
              Clarity in an increasingly connected global economy.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-7 max-w-xl text-base leading-relaxed text-navy-900/65 sm:text-lg">
              EXIMNEX Technologies is a business and trade intelligence company
              focused on delivering meaningful market insights, strategic
              research and analytical solutions. We help businesses understand
              markets, identify opportunities and make informed decisions in an
              increasingly connected global economy.
            </p>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-navy-900/65">
              Our practice spans import–export intelligence, business and trade
              analytics, buyer–supplier research, competitor intelligence,
              market research and strategic business intelligence — each
              delivered through the same disciplined, research-driven method.
            </p>
          </Reveal>
        </div>

        <div className="flex flex-col justify-center gap-2 lg:pl-10">
          {POINTS.map((p, i) => (
            <Reveal key={p.title} delay={0.12 * i}>
              <div
                data-testid={`about-point-${i}`}
                className="group flex items-start gap-6 rounded-2xl border border-transparent px-5 py-6 transition-all duration-300 hover:border-navy-900/10 hover:bg-mist"
              >
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl border border-royal/15 bg-royal/5 text-royal transition-colors duration-300 group-hover:bg-royal group-hover:text-white">
                  <p.icon className="h-5 w-5" strokeWidth={1.6} />
                </span>
                <div>
                  <h3 className="font-display text-lg text-navy-900">{p.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-navy-900/60">{p.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
